import { render, staticRenderFns } from "./in-search-area.vue?vue&type=template&id=fca0cbe2"
import script from "./in-search-area.vue?vue&type=script&lang=js"
export * from "./in-search-area.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports